import { render } from "./NewProject.vue?vue&type=template&id=ad0cf736&ts=true"
import script from "./NewProject.vue?vue&type=script&lang=ts"
export * from "./NewProject.vue?vue&type=script&lang=ts"

import "./NewProject.vue?vue&type=style&index=0&id=ad0cf736&scope=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__